import { AUTH_PREFIX_PATH, DOCS_PREFIX_PATH } from "configs/AppConfig";
import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import { styles } from "./styles";

export const DocsViews = withRouter(() => (
	<Switch>
		<Route path={DOCS_PREFIX_PATH + "/catalogo"}>
			<iframe
				allow="autoplay"
				height="100%"
				src="https://drive.google.com/file/d/1huWCVyQ6eSykp0mJZHhjc-fUBv-mDTvG/preview"
				style={styles.container}
				title="Catálogo de produtos"
				width="100%"
			/>
		</Route>

		<Route path={DOCS_PREFIX_PATH + "/manual-consultor"}>
			<iframe
				allow="autoplay"
				height="100%"
				src="https://drive.google.com/file/d/1Vxvk4hHMVEuR4Uk0lfxSYuCkPKmi5awp/preview"
				style={styles.container}
				title="Manual do consultor"
				width="100%"
			/>
		</Route>

		<Redirect from={DOCS_PREFIX_PATH} to={AUTH_PREFIX_PATH} />
	</Switch>
));
